import { ConfigService } from './../../../services/config.service';
import {
  Component,
  AfterViewInit,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReadableDisplayPipe } from '../../../pipes/readable-display.pipe';
import { CustomDateFormatPipe } from '../../../pipes/date-format-pipe';
import { UnsubscribeOnDestroyAdapter } from '../../../subscription/unsubscribe-ondestroy-adapter';
import { UserService } from '../../../services/user.service';
import { ActViewerService } from '../../../services/act-viewer.service';
import UIConstants from '../../../../app-constants/ui-constants';
import { ILogData } from '../../../../submodules/silverlight-common/lib/ts/src/interface/log.data.interface';
import { IConfigData } from '../../../../submodules/silverlight-common/lib/ts/src/interface/config.data.interface';

@Component({
  selector: 'app-grid',
  standalone: true,
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ReadableDisplayPipe,
    MatSortModule,
    CustomDateFormatPipe,
    MatTooltipModule,
  ],
  templateUrl: './grid.component.html',
  styleUrl: './grid.component.scss',
})
export class GridComponent
  extends UnsubscribeOnDestroyAdapter
  implements AfterViewInit {
  productTypeObject!: Record<string, string | undefined >
  productTypes!: string[];
  constructor(
    private userService: UserService,
    private actViewerService: ActViewerService,
    private configService: ConfigService
  ) {
    super();
  }
  ngAfterViewInit(): void {
    if (this.gridType === this.gridConstants.GRID_TYPE.USER)
      this.subs.sink = this.userService.userProfileList$.subscribe((data) => {
        console.log(this.gridType);
        console.log('DATA', data);
        this.dataObject = data;
        this.initializeGrid();
      });
    this.configService.configData$.subscribe((data) => {
      if (data) {
        const configDataJson = data?.find((config: IConfigData) => {
          return config?.keyName === 'InjectorTypes';
        })
          ?.keyValue
        const configDataObject = JSON.parse(configDataJson ?? '');
        this.productTypes = Object.keys(configDataObject)
        this.productTypeObject = configDataObject
      }
    })
    if (this.gridType === this.gridConstants.GRID_TYPE.LOG)
      this.subs.sink = this.actViewerService.logDataList$.subscribe((data) => {
        console.log(this.gridType);
        console.log('DATA', data);
        this.dataObject = data;
        this.initializeGrid();
      });
  }
  dataObject: any = []; //DisplayUser[] | DisplayLogs[]; // actual user and act view object
  @Input() gridType: string = '';
  @Output() editUserEvent = new EventEmitter<any>();
  @Output() jsonDisplayEvent = new EventEmitter<any>();
  @Output() jsonDisplayLogsEvent = new EventEmitter<any>();
  @Output() rowDataRef = new EventEmitter<any>();
  rowData = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  gridConstants = UIConstants.Grid;
  get columnDefs(): string[] {
    if (this.gridType === this.gridConstants.GRID_TYPE.USER)
      return [
        'userName',
        'userFirstName',
        'userLastName',
        'userEmailId',
        'userAssignedRole',
        'userProductTypes',
        'userProductInjectorIDs',
        'userLicenseExpirationDateTime',
        'userUpdatedDateTime',
        'userIsActive',
      ];
    if (this.gridType === this.gridConstants.GRID_TYPE.LOG) {
      return [
        'logEventDateTime',
        'logEventType',
        'logSrcSystem',
        'logUserName',
        'logMessage',
      ];
    }
    return [];
  }
  editUser(user: any) {
    this.editUserEvent.emit(user);
  }
  jsonDisplay(displaySelection: any) {
    this.jsonDisplayEvent.emit(displaySelection);
  }
  jsonDisplayLogs(user: any) {
    this.jsonDisplayLogsEvent.emit(user);
  }
  initializeGrid(): void {
    let displayObject: any;
    console.log('SDFGHJKL>:', this.dataObject);
    displayObject = this.dataObject?.responseData;

    if (displayObject && this.gridType === this.gridConstants.GRID_TYPE.USER
    )
      displayObject = displayObject.sort((a: any, b: any) => {
        const dateA = new Date(
          a.userUpdatedDateTime || a.userCreatedDateTime
        ).getTime();
        const dateB = new Date(
          b.userUpdatedDateTime || b.userCreatedDateTime
        ).getTime();
        return dateB - dateA;
      });
    if (displayObject && this.gridType === this.gridConstants.GRID_TYPE.LOG) displayObject = displayObject.sort((a: ILogData, b: ILogData) => {
      return new Date(b.logEventDateTime).getTime() - new Date(a.logEventDateTime).getTime()
    })
    console.log('DO LENGTH', displayObject?.length);
    if (!displayObject) return;
    console.log('IN app-grid', displayObject);
    this.rowData = new MatTableDataSource<any>(displayObject);
    this.paginator.pageSize = 20;
    this.rowData.paginator = this.paginator;
    this.rowData.sort = this.sort;
    this.rowDataRef.emit(this.rowData);
  }
  override ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
